
export const FORM_FIELDS_NAMES = {
    APPOINTMENT_DATE_TIME: 'date',
    APPOINTMENT_TYPE: 'appointmentType',
    RENDERING_PROVIDER: 'providerId',
    AGE: 'ageAtEncounter',
    LOCATION: 'locationId',
    POS: 'placeOfService'
}